import useGetProductListQuery from '@/api/queries/useGetProductListQuery';
import Button from '@/components/Button';
import { ProductListEditPath } from '@/modules/product/paths';
import { Link } from 'react-router-dom';

const EffectiveProductListSummary = ({ productListId }: { productListId: string }) => {
  const { productList, isLoading, error, invalidateQuery } = useGetProductListQuery(productListId);

  return (
    <li className="px-4 py-3">
      {isLoading ? (
        <p role="status" className="text-sm text-gray-600">
          Loading Product List…
        </p>
      ) : error || !productList ? (
        <div className="flex flex-wrap items-center justify-between gap-3">
          <p className="text-sm text-gray-600">
            Details unavailable for Product List {productListId}.
          </p>
          <Button variant="secondary" size="xs" onClick={() => void invalidateQuery()}>
            Retry details
          </Button>
        </div>
      ) : (
        <>
          <Link
            className="font-medium text-blue-600 hover:underline"
            to={ProductListEditPath.withId(productList.id)}
          >
            {productList.name}
          </Link>
        </>
      )}
    </li>
  );
};

export default EffectiveProductListSummary;
